import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {
	TwoFactorAuthorization,
	TwoFaModalControl,
	TwoFaRecoverDataToSend,
	TwoFaSetupData
} from '@models/two-fa.models';
import { ServerDataResponse } from '@models/models';

@Injectable()
export class TwoFaAuthenticationDataService {
	private twoFaModalControl$: BehaviorSubject<
		TwoFaModalControl
	> = new BehaviorSubject<TwoFaModalControl>(null);

	constructor(private http: HttpClient) {}

	get2FaMetadataForSetup(): Observable<
		ServerDataResponse<TwoFactorAuthorization>
	> {
		const url = '/api/user/profile/2fa/setup-metadata';
		return this.http.get(url) as Observable<
			ServerDataResponse<TwoFactorAuthorization>
		>;
	}

	setup2FaAuthentication(
		url: string,
		method: string,
		data: TwoFaSetupData
	): Observable<Object> {
		return this.http[method.toLowerCase()](url, data);
	}

	getQRUrl(url: string): Observable<HttpResponse<Blob>> {
		return this.http.get(url, { observe: 'response', responseType: 'blob' });
	}

	send2FAAction(url: string, method: string): Observable<Object> {
		return this.http[method.toLowerCase()](url, {});
	}

	reset2FaAuthentication(
		url: string,
		method: string,
		data: TwoFaRecoverDataToSend
	): Observable<Object> {
		return this.http[method.toLowerCase()](url, data);
	}

	// Two Factor Authentication modal triggers

	get twoFaModalControlState(): Observable<TwoFaModalControl> {
		return this.twoFaModalControl$.asObservable();
	}

	setTwoFaModalControlState(state: TwoFaModalControl): void {
		this.twoFaModalControl$.next(state);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/user/two-fa-authentication.data.service.ts